import { ReactNode } from 'react'

import { clsx } from 'clsx'

export type HelperTextProps = {
  invalid?: boolean
  className?: string
  children?: ReactNode
}
export const HelperText = ({
  invalid = false,
  children,
  className,
}: HelperTextProps) => {
  return (
    <p
      className={clsx(
        'text-sm first-letter:capitalize',
        !invalid && 'text-content-subdued',
        invalid && 'text-action-destructive',
        className,
      )}
    >
      {children}
    </p>
  )
}
